import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CheckCircle2, MessageCircle, ArrowLeft, AlertCircle } from "lucide-react";
import SiteHeader from "../components/SiteHeader";
import SiteFooter from "../components/SiteFooter";
import { useCms } from "../lib/cms";

export default function ThankYouEntruempelung() {
  const { cms } = useCms();
  const rawPhone = (cms?.legal?.impressum?.phone) || "+49 176 56198464";
  const digits = rawPhone.replace(/\D/g, "") || "4917656198464";
  const [fallback, setFallback] = useState(null);

  useEffect(() => {
    document.title = "Vielen Dank | Entrümpelung · Leukas Umzug";
    let robots = document.querySelector('meta[name="robots"]');
    if (!robots) {
      robots = document.createElement("meta");
      robots.setAttribute("name", "robots");
      document.head.appendChild(robots);
    }
    robots.setAttribute("content", "noindex, nofollow");

    try {
      const raw = sessionStorage.getItem("leukas_last_wa");
      if (raw) {
        const obj = JSON.parse(raw);
        if (obj && obj.url) setFallback(obj);
        sessionStorage.removeItem("leukas_last_wa");
      }
    } catch (_) {}

    return () => { if (robots) robots.setAttribute("content", "index, follow"); };
  }, []);

  const genericWaHref = `https://wa.me/${digits}?text=${encodeURIComponent("Hallo, ich habe gerade eine Entrümpelung angefragt.")}`;

  return (
    <div className="min-h-screen flex flex-col">
      <SiteHeader />
      <main className="flex-1 max-w-2xl mx-auto w-full px-4 sm:px-6 lg:px-8 py-16 sm:py-24 text-center">
        <div className="mx-auto w-16 h-16 rounded-2xl bg-green-100 text-green-700 grid place-items-center shadow-soft">
          <CheckCircle2 size={36} />
        </div>
        <h1 className="mt-6 text-3xl sm:text-4xl font-heading font-extrabold text-slate-900">
          Vielen Dank für Ihre Anfrage
        </h1>
        <p className="mt-3 text-slate-600 text-lg leading-relaxed">
          Wir melden uns innerhalb von 60 Minuten und stimmen die kostenlose Besichtigung mit Ihnen ab.
        </p>

        {fallback?.popupBlocked && fallback?.url && (
          <div className="mt-8 rounded-2xl border-2 border-amber-300 bg-amber-50 p-5 text-left sm:text-center" data-testid="wa-fallback-block">
            <div className="flex items-start sm:items-center sm:justify-center gap-2 text-amber-900 mb-3">
              <AlertCircle size={18} className="mt-0.5 sm:mt-0 shrink-0" />
              <div className="text-sm font-semibold">
                Ihr Browser hat WhatsApp nicht automatisch geöffnet.
              </div>
            </div>
            <a
              href={fallback.url}
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center justify-center gap-2 rounded-xl bg-brand-amber text-brand-navy px-6 py-4 text-base font-extrabold shadow-soft hover:bg-amber-300 transition-colors w-full sm:w-auto"
              data-testid="wa-fallback-btn"
            >
              <MessageCircle size={18} /> Anfrage jetzt per WhatsApp senden
            </a>
            <p className="mt-2 text-[12px] text-amber-900/80">
              Ihre Daten sind bereits vorbereitet – nur noch auf Senden tippen.
            </p>
          </div>
        )}

        <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
          {!fallback?.popupBlocked && (
            <a
              href={fallback?.url || genericWaHref}
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center justify-center gap-2 rounded-xl bg-brand-amber text-brand-navy px-6 py-3.5 font-bold hover:bg-amber-300 transition-colors"
              data-testid="ty-wa"
            >
              <MessageCircle size={18} /> Per WhatsApp schreiben
            </a>
          )}
          <Link
            to="/"
            className="inline-flex items-center justify-center gap-2 rounded-xl border-2 border-slate-200 text-slate-700 bg-white px-6 py-3.5 font-semibold hover:bg-slate-50 transition-colors"
            data-testid="ty-home"
          >
            <ArrowLeft size={16} /> Zurück zur Startseite
          </Link>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}
